// extracted by mini-css-extract-plugin
export default {"host":"style_host__9LEv2","editor":"style_editor__RQd-Z"};